import { getItemMaker } from "./tools";

const food = getItemMaker("cooking foods");
export const cookingFoods = [
  food("Turkey a la Thank"),
  food("Egg"),
  food("Salad"),
  food("Pie"),
  food("Frenk Fries"),
  food("Spaghetti"),
  food("Corn"),
  food("Garlic Bread"),
  food("Garlicless Bread"),
  food("Pizza"),
  food("Apple"),
  food("Pancakes"),
  food("Corndog"),
  food("Cabbage"),
  food("Potato Pea Pastry"),
  food("Dango"),
  food("Sourish Fish"),
  food("Octoplop"),
  food("Croissant"),
  food("Canopy"),
  food("Cannoli"),
  food("Cheese"),
  food("Sawdust"),
  food("Eggplant"),
  food("Cheesy Bread"),
  food("Wild Boar"),
  food("Donut"),
  food("Riceball"),
  food("Cauliflower"),
  food("Durian Fruit"),
  food("Orange"),
  food("Bunt Cake"),
  food("Chocolate Truffle"),
  food("Leek"),
  food("Fortune Cookie"),
  food("Pretzel"),
  food("Sea Urchin"),
  food("Mashed Potato"),
  food("Mutton"),
  food("Wedding Cake"),
  food("Eel"),
  food("Whipped Cocoa"),
  food("Onion"),
  food("Soda"),
  food("Sushi Roll"),
  food("Buncha Banana"),
  food("Pumpkin"),
  food("Cotton Candy"),
  food("Massive Fig"),
  food("Head Chef Bread"),
  food("Kiwi Fruit"),
  food("Popped Corn"),
  food("Double Cherry"),
  food("Ratatouey"),
  food("Giant Tomato"),
  food("Wrath Grapes"),
  food("Sausy Sausage"),
  food("Seasoned Marrow"),
  food("Sticky Bun"),
  food("Frazzleberry"),
  food("Misterloin Steak"),
  food("Large Pohayoh"),
  food("Bill Jack Pepper"),
  food("Burned Marshmallow"),
  food("Yumi Peachring"),
  food("Plumpcakes"),
  food("Nyanborgir"),
];

export const cookingProduction = [
  "Turkey a la Thank",
  "Egg",
  "Salad",
  "Pie",
  "Frenk Fries",
  "Spaghetti",
  "Corn",
  "Garlic Bread",
  "Garlicless Bread",
  "Pizza",
  "Apple",
  "Pancakes",
  "Corndog",
  "Cabbage",
  "Potato Pea Pastry",
  "Dango",
  "Sourish Fish",
  "Octoplop",
  "Croissant",
  "Canopy",
  "Cannoli",
  "Cheese",
  "Sawdust",
  "Eggplant",
  "Cheesy Bread",
  "Wild Boar",
  "Donut",
  "Riceball",
  "Cauliflower",
  "Durian Fruit",
  "Orange",
  "Bunt Cake",
  "Chocolate Truffle",
  "Leek",
  "Fortune Cookie",
  "Pretzel",
  "Sea Urchin",
  "Mashed Potato",
  "Mutton",
  "Wedding Cake",
  "Eel",
  "Whipped Cocoa",
  "Onion",
  "Soda",
  "Sushi Roll",
  "Buncha Banana",
  "Pumpkin",
  "Cotton Candy",
  "Massive Fig",
  "Head Chef Bread",
  "Kiwi Fruit",
  "Popped Corn",
  "Double Cherry",
  "Ratatouey",
  "Giant Tomato",
  "Wrath Grapes",
  "Sausy Sausage",
  "Seasoned Marrow",
  "Sticky Bun",
  "Frazzleberry",
  "Misterloin Steak",
  "Large Pohayoh",
  "Bill Jack Pepper",
  "Burned Marshmallow",
  "Yumi Peachring",
  "Plumpcakes",
  "Nyanborgir",
];
